import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { CclDrawerService, CclBuilderService, CclMessageService, CclNavbarFooterService } from "certain-common-library";

import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { LocalDataService } from "../../../../../modules/shared/services/local-data.service";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-speaker-sessions-page",
    templateUrl: "./speaker-sessions-page.view.html",
    styleUrls: []
})
export class SpeakerSessionsPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    speakerSessionConfigObj: any;

    speakerSessionConfig: any = {};
    basedOnImageName: any = {};

    ddfData: Array<any> = [];
    hover = false;
    templateStyles: any = {
        l_circular: "Layout w/ Circular Image",
        l_noimage: "Layout without Image",
        l_square: "Layout w/ Square Image",
        l_banner: "Layout w/ Banner Image"
    };
    bodyLayout: string;
    fontstyle: any = {};

    constructor(
        public sharedService: SharedService,
        private drawerService: CclDrawerService,
        public builderService: CclBuilderService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private localDataService: LocalDataService
    ) {
        super(sharedService);
        this.localDataService.getJSON("session-ddf.json").subscribe((data) => {
            if (data != null) {
                this.ddfData = data;
            }
            if (this.sharedService.sessionCustomFields != null) {
                this.sharedService.sessionCustomFields.forEach((cf) => {
                    this.ddfData.push({
                        label: cf.name,
                        key: "{@ddf.customFieldMap." + cf.code.replace(/ /g, "") + "@}",
                        type: "Session custom field"
                    });
                });
            }
            this.bodyLayout = this.getFormattedDDFData("body");
        });
        this.subscription = this.messageService
            .getMessage()
            .subscribe((message) => this.saveSpeakerSessionConfig(message));
    }

    getFormattedDDFData(expansionStyle) {
        let contentString = this.sharedService.sessionLayoutConfig.catalogConfig[expansionStyle].textConfig.template;
        if (contentString != null) {
            this.ddfData.forEach(function(value, key) {
                if (contentString.indexOf(value.key) > -1) {
                    contentString = contentString.replace(new RegExp(value.key, "g"), value.label);
                }
            });
            return contentString
                .replace(new RegExp('contenteditable="true"', "g"), "")
                .replace(new RegExp("contenteditable='true'", "g"), "");
        } else {
            return "";
        }
    }

    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.sharedService.currentLayoutSection = "speaker-sessions";
        this.speakerSessionConfigObj = this.sharedService.configs[
            this.sharedService.configTypes.SPEAKER_SESSION_CONFIG
        ];
        if (this.speakerSessionConfigObj == null || this.speakerSessionConfigObj.id == null) {
            this.speakerSessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig);
            this.speakerSessionConfigObj = {
                id: null,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: null,
                configType: this.sharedService.configTypes.SPEAKER_SESSION_CONFIG
            };
        } else {
            this.speakerSessionConfig = JSON.parse(this.speakerSessionConfigObj.config);
            this.sharedService.sessionLayoutConfig = cloneDeep(this.speakerSessionConfig);
        }

        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.speakerSessionConfig);
        this.sharedService.changedData = this.speakerSessionConfig;

        this.fontstyle = {
            color: this.speakerSessionConfig.labelConfig.fontColor,
            "font-style": this.speakerSessionConfig.labelConfig.fontStyle,
            "text-decoration": this.speakerSessionConfig.labelConfig.fontStyle,
            "font-weight": this.speakerSessionConfig.labelConfig.fontStyle,
            "font-size": this.speakerSessionConfig.labelConfig.fontSize + "px",
            "padding-right": "5px"
        };
        this.setBasedOnImageNameHelper("body");
    }

    private setBasedOnImageNameHelper(property) {
        if (this.speakerSessionConfig.catalogConfig[property].imageConfig.basedOn == "speaker_img") {
            this.basedOnImageName[property] = "Speaker <br/> Profile <br/> Image";
        } else if (this.speakerSessionConfig.catalogConfig[property].imageConfig.basedOn == "dynamic_img") {
            var img = this.speakerSessionConfig.catalogConfig[property].imageConfig.dynamicImage;
            var filename = img.replace(/^.*[\\\/]/, "");
            var encodeFileName = encodeURIComponent(filename);
            var imgURL = img.replace(filename, encodeFileName);
            var imgHeight = this.speakerSessionConfig.catalogConfig[property].imageConfig.height;
            var imgWidth = this.speakerSessionConfig.catalogConfig[property].imageConfig.width;
            if (this.speakerSessionConfig.layout == "l_circular") {
                this.basedOnImageName[property] =
                    "<img style='opacity: .8' alt='Dynamic image uploaded' class='img-border-radius' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            } else if (this.speakerSessionConfig.layout == "l_square") {
                this.basedOnImageName[property] =
                    "<img style='opacity: .8' alt='Dynamic image uploaded' height=" +
                    imgHeight +
                    " width=" +
                    imgWidth +
                    " src=" +
                    imgURL +
                    ">";
            }
        } else {
            if (this.sharedService.speakerFileCustomFields != null) {
                this.sharedService.speakerFileCustomFields.forEach((cf) => {
                    if ("custom_" + cf.code == this.speakerSessionConfig.catalogConfig[property].imageConfig.basedOn) {
                        this.basedOnImageName[property] = cf.name;
                    }
                });
            }
        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Data for featured section";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-speaker-session";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-speaker-session";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    saveSpeakerSessionConfig(message) {
        if (message.text == "save-speaker-session" || message.text == "save-next-speaker-session") {
            this.speakerSessionConfigObj.config = JSON.stringify(this.speakerSessionConfig);
            this.catalogService.saveSetupConfig(this.speakerSessionConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.speakerSessionConfig);
                this.sharedService.changedData = this.speakerSessionConfig;

                this.speakerSessionConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                this.sharedService.configs[
                    this.sharedService.configTypes.SPEAKER_SESSION_CONFIG
                ] = this.speakerSessionConfigObj;
                this._flashMessagesService.show("Speaker layout saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-speaker-session") {
                    this.sharedService.currentLayoutSection = "highlighted";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/data/highlighted");
                }
            });
        } else if (message.text == "apply-speaker-session-config") {
            // For checking IE borwser
            if(!this.sharedService.isMSIE()) {
            window.dispatchEvent(new Event("resize"));
            }
            this.speakerSessionConfig = cloneDeep(this.sharedService.sessionLayoutConfig);
            // For checking unsaved data
            this.sharedService.changedData = this.speakerSessionConfig;

            this.drawerService.hideDrawer();

            this.fontstyle = {};
            setTimeout(() => {
                this.fontstyle = {
                    color: this.speakerSessionConfig.labelConfig.fontColor,
                    "font-style": this.speakerSessionConfig.labelConfig.fontStyle,
                    "text-decoration": this.speakerSessionConfig.labelConfig.fontStyle,
                    "font-weight": this.speakerSessionConfig.labelConfig.fontStyle,
                    "font-size": this.speakerSessionConfig.labelConfig.fontSize + "px",
                    "padding-right": "5px"
                };
            }, 0);
            this.setBasedOnImageNameHelper("body");
            this.bodyLayout = this.getFormattedDDFData("body");
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.sessionLayoutConfig = cloneDeep(this.speakerSessionConfig);
        this.sharedService.expansionStyle = expansionStyle;
        if (item == "template") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Choose a different Template",
                navLinks: null,
                saveMessage: "apply-speaker-session-config"
            };
            url = "config-drawer/speaker-sessions/template-config";
        } else if (item == "img") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Dynamic Image",
                navLinks: null,
                saveMessage: "apply-speaker-session-config"
            };
            url = "config-drawer/speaker-sessions/image-config";
        } else if (item == "region") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Region",
                navLinks: null,
                saveMessage: "apply-speaker-session-config"
            };
            url = "config-drawer/speaker-sessions/region-config";
        } else if (item == "html") {
            this.drawerService.toggleDrawer("mid");
            this.sharedService.currentDrawer = {
                title: "Edit Text",
                navLinks: null,
                saveMessage: "apply-speaker-session-config"
            };
            url = "config-drawer/speaker-sessions/html-config";
        } else if (item == "label") {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Label",
                navLinks: null,
                saveMessage: "apply-speaker-session-config"
            };
            url = "config-drawer/speaker-sessions/label-config";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }
}
